export default function EditorialRibbon({ items }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap font-mono-ui text-[11px] uppercase tracking-[0.32em] text-[#8E95A5]">
            {item}
          </span>
          <span className="mx-8 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#8B5CF6]/60" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="relative overflow-hidden border-y border-white/[0.07] bg-[#0C0E14]/60 py-5"
      data-testid="editorial-ribbon"
    >
      <div className="animate-marquee flex w-max">
        {row(false)}
        {row(true)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#07080B] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#07080B] to-transparent" />
    </div>
  );
}
